'use client';

import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger, SplitText } from 'gsap/all';
import { useResizeObserver } from '@weareconceptstudio/core';

//! Plugins
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

const TitleAnim = ({
	animTitle,
	animRef,
	duration,
	stagger,
	delay,
	once = false,
	children,
	starting,
	start,
	triggerRef,
	dep = [],
	revertTriggerRef,
	update = true,
}) => {
	//! Ref
	const scrollTriggerRef = useRef();
	const splitTextRef = useRef();
	const revertAnim = useRef();
	const variableControlAnimation = useRef(false);

	const resize = update ? useResizeObserver(document.querySelector('main')) : null;

	useEffect(() => {
		if (!animRef.current) return;

		starting = starting == undefined ? true : starting;
		const trigger = triggerRef?.current ? triggerRef.current : animRef.current;

		const revertTrigger = revertTriggerRef?.current ? revertTriggerRef.current : animRef.current;

		if (animTitle && starting && animRef.current) {
			const controller = {
				delay: delay || 0,
				duration: duration || 0.3,
				stagger: stagger || 0.03,
				start: start || '80%',
			};

			scrollTriggerRef.current = ScrollTrigger.create({
				// markers: true,
				trigger: trigger,
				start: `top ${controller.start}`,
				end: 'top top',
				once: once,
				onEnter: () => {
					if (!variableControlAnimation.current) {
						variableControlAnimation.current = true;
						splitTextRef.current = new SplitText(animRef.current, { type: 'lines chars' });
						if (splitTextRef.current.chars && animRef.current) {
							gsap.fromTo(
								splitTextRef.current.chars,
								{ opacity: 0, y: '100%' },
								{
									opacity: 1,
									y: 0,
									duration: controller.duration,
									ease: 'power2.out',
									delay: controller.delay,
									// stagger: 0.02,
									stagger: controller.stagger,
								}
							);

							gsap.to(animRef.current, { opacity: 1, duration: 0 });
							gsap.fromTo(
								splitTextRef.current.chars,
								{ y: '100%', scale: 0 },
								{
									y: 0,
									scale: 1,
									ease: 'power2.out',
									delay: controller.delay,
									duration: controller.duration,
									stagger: controller.stagger,
								}
							);
						}
					}
				},
				// onLeaveBack: () => {
				// 	if (splitTextRef.current && !once) splitTextRef.current.revert();
				// 	gsap.set(animRef.current, { opacity: 0, duration: 0 });
				// },
			});
			if (!once) {
				revertAnim.current = ScrollTrigger.create({
					trigger: revertTrigger,
					start: `top bottom`,
					end: 'top top',
					// markers: true,
					onLeaveBack: () => {
						if (variableControlAnimation.current) {
							if (splitTextRef.current && !once) splitTextRef.current.revert();
							gsap.set(animRef.current, { opacity: 0 });
							variableControlAnimation.current = false;
						}
					},
				});
			}
		}

		return () => {
			if (scrollTriggerRef.current) {
				scrollTriggerRef.current.kill();
				scrollTriggerRef.current = null;
			}
			if (splitTextRef.current) {
				splitTextRef.current.revert();
				splitTextRef.current = null;
			}
			if (revertAnim.current) {
				revertAnim.current.kill();
				revertAnim.current = null;
			}
			variableControlAnimation.current = false;
		};
	}, [animRef.current, starting, ...dep]);

	return children;
};

export default TitleAnim;
